<template>
	<div
		class="bg-brand-900 z-20"
	>
		<div class="container flex justify-between items-stretch">
			<div class="flex items-stretch">
				<div class="flex items-stretch sm:mr-8">
					<AtomLink
						v-bind="fysioLink"
						class="text-brand-200 text-functional-size-xs uppercase tracking-wide hover:bg-purple-800 touch:h-16 cursor:h-12 flex items-center px-5"
					>
						Fysio
					</AtomLink>
					<p class="text-brand-100 text-functional-size-xs uppercase tracking-wide bg-purple-800 touch:h-16 cursor:h-12 flex items-center px-5">
						<span class="sr-only">Huidige site</span>
						Fit
					</p>
				</div>
				<AtomLink
					v-for="item of menuSocialItems"
					:key="`service-menu-social-item-${item.to.url}`"
					v-bind="item.to"
					class="hidden sm:flex text-brand-200 text-functional-size-md uppercase tracking-wide hover:bg-purple-800 touch:h-16 cursor:h-12 items-center px-2 sm:px-5 gap-2"
				>
					<AtomFontAwesome
						:icon="item.icon"
						library="fab"
					/>
					<span class="sr-only">{{ item.text }}</span>
				</AtomLink>
			</div>
			<div class="flex items-stretch">
				<AtomLink
					v-for="item of menuServiceItems"
					:key="`service-menu-item-${item.to.url}`"
					v-bind="item.to"
					class="text-brand-200 text-functional-size-xs uppercase tracking-wide hover:bg-purple-800 touch:h-16 cursor:h-12 flex items-center px-2 sm:px-5 gap-2"
				>
					<AtomFontAwesome
						class="size-6"
						:icon="item.icon"
					/>
					<span>{{ item.text }}</span>
				</AtomLink>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { fysioLink } from '#base/core/consts/links';
import type { SubHeaderMenuItemType } from '#base/core/types/SubHeaderMenuItemType';

const {
	menuSocialItems = [],
	menuServiceItems = [],
} = defineProps<{
	menuSocialItems?: SubHeaderMenuItemType[];
	menuServiceItems?: SubHeaderMenuItemType[];
}>();
</script>
